let pending = null;

export function requestContactPrefill(message) {
  pending = message;
  window.dispatchEvent(new Event("korban:contact-prefill"));
}

export function subscribeContactPrefill(cb) {
  const handler = () => {
    if (pending) {
      cb(pending);
      pending = null;
    }
  };
  window.addEventListener("korban:contact-prefill", handler);
  return () => window.removeEventListener("korban:contact-prefill", handler);
}
